import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
import { AxiosErrorException } from '@hems/util/src/exception/exception';
export default class DownloadService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** 연간 리포트 파일 다운로드 */
    annualReportFileDownload = async (siteId, params) => {
        return await this.get(apiWrapper.managerApi(`/histories/annual-reports/${siteId}/file`), params, {
            headers: {
                Accept: '*/*',
            },
            responseType: 'blob',
        });
    };
    /** 연간 리포트 이메일 전송 */
    annualReportSendEmail = async (siteId, params, config) => {
        const url = apiWrapper.managerApi(`/histories/annual-reports/${siteId}/mail`);
        try {
            const { status } = await this.axios.post(url, params, config);
            return { status };
        }
        catch (e) {
            throw new AxiosErrorException(url, params, e);
        }
    };
}
